export const properties = {
    host: "https://api.rexiusalgorithms.com",
    // Cloudflare Turnstile site key (dashboard -> Turnstile). Blank hides the captcha;
    // the matching secret key lives in the backend application.yml and both must be set together.
    turnstileSiteKey: "0x4AAAAAAEdWvSm-COgmcpxS"
};
